import DashboardService from '@/services/DashboardService';
const state = {
  footerAddress: '',
};

const getters = {
  footerAddress: (state) => state.footerAddress,
};

const actions = {
  async fetchFooterAddress({ commit }) {
    try {
      const data = await DashboardService.getAddress();
      const addressList = data.contents || [];
      // Get the last address with type ADDRESS
      const lastAddress = addressList.filter((item) => item.type === 'ADDRESS').sort((a, b) => b.id - a.id)[0];

      commit('SET_FOOTER_ADDRESS', lastAddress?.remark || '');
    } catch (error) {
      console.error('Failed to fetch footer address:', error);
    }
  },
};

const mutations = {
  SET_FOOTER_ADDRESS(state, address) {
    state.footerAddress = address;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
